import axios from 'axios'

const http = axios.create({ baseURL: '/api', timeout: 10000 })

http.interceptors.response.use(
  res => res.data,
  err => Promise.reject(err)
)

export default {
  getPublicTenant() {
    return http.get('/tenant/public')
  }
}
